<template>
  <div
    v-if="!firstOpen"
    class="drawer"
    :class="[{slideIn: !!isOpen, slideOut: !isOpen}, widthCss]"
    :style="{width: widthStyle}"
  >
    <!-- <div class="exit" v-on:click="close">
      <span class="icon-cross2"></span>
    </div>-->
    <div class="uiDrawerInner">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import { setTimeout } from "timers";
export default {
  props: ["onClose", "isOpen", "width"],
  methods: {
    close() {
      this.isOpen = false;
      if (typeof this.onClose === "function") this.onClose();
    }
  },
  watch: {
    isOpen: function(val) {
      if (val) this.firstOpen = false;
    },
    width: function(val) {
      if (["full", "half"].indexOf(val) > -1) {
        this.widthCss = val;
        this.widthStyle = undefined;
      } else {
        this.widthCss = "";
        this.widthStyle = val;
      }
    }
  },
  data() {
    return {
      firstOpen: true,
      widthCss: "",
      widthStyle: undefined
    };
  }
};
</script>

<style>
</style>
